/* Test-theme fixed bundles: preserve physical quantities and unrelated cart lines. */
(() => {
  if (window.HpmBundleCart) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const plain = item => !item.selling_plan_allocation && !Object.keys(item.properties || {}).length;
  function plan(cart, rules) {
    const updates = {}, totals = {};
    for (const [singleId, rule] of Object.entries(rules || {})) {
      if (!rule.ready) continue;
      const singles = cart.items.filter(i => String(i.variant_id) === singleId && plain(i));
      const packs = cart.items.filter(i => String(i.variant_id) === String(rule.bundleVariant) && plain(i));
      const unitCount = singles.reduce((n,i)=>n+i.quantity,0);
      const packCount = packs.reduce((n,i)=>n+i.quantity,0);
      if (unitCount < rule.quantity) continue;
      const groups = packCount + Math.floor(unitCount / rule.quantity), remainder = unitCount % rule.quantity;
      singles.forEach((i,n)=>{updates[i.key]=n===0?remainder:0;});
      if (packs.length) packs.forEach((i,n)=>{updates[i.key]=n===0?groups:0;});
      else updates[rule.bundleVariant]=groups;
      totals[singleId] = unitCount + packCount * rule.quantity;
    }
    return {updates,totals};
  }
  async function json(url, options) {
    const r=await fetch(url,options), data=await r.json();
    if(!r.ok||data.status>=400||data.errors)throw Error(data.description||data.message||'購物車更新失敗，請重新整理後再試。');
    return data;
  }
  async function normalize(sections, sectionsUrl) {
    const cart=await json(root()+'cart.js',{credentials:'same-origin',cache:'no-store'});
    const rules=window.hpmRoyalBundles||{}, p=plan(cart,rules);
    if(!Object.keys(p.updates).length)return {cart,changed:false};
    const result=await json(root()+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:p.updates,sections,sections_url:sectionsUrl||location.pathname})});
    for(const [singleId,total] of Object.entries(p.totals)){
      const rule=rules[singleId];
      const actual=result.items.filter(plain).reduce((n,i)=>n+(String(i.variant_id)===singleId?i.quantity:String(i.variant_id)===String(rule.bundleVariant)?i.quantity*rule.quantity:0),0);
      if(actual!==total)throw Error('組合數量核對失敗，請先檢查購物車，暫勿結帳。');
    }
    const affected=new Set(Object.keys(p.totals).flatMap(id=>[id,String(rules[id].bundleVariant)]));
    for(const old of cart.items.filter(i=>!affected.has(String(i.variant_id))||!plain(i))){
      if(!result.items.some(i=>i.key===old.key&&i.quantity===old.quantity))throw Error('購物車其他商品需要重新核對，請暫勿結帳。');
    }
    return {cart:result,changed:true};
  }
  let queue=Promise.resolve();
  const serial=fn=>{const next=queue.catch(()=>{}).then(fn);queue=next;return next;};
  const fail=error=>new Response(JSON.stringify({status:422,errors:error.message,description:error.message}),{status:422,headers:{'Content-Type':'application/json'}});
  async function perform(url,config,kind){
    let body=config.body instanceof FormData?Object.fromEntries(config.body):JSON.parse(config.body||'{}');
    const original=await fetch(url,config);
    const data=await original.clone().json();
    if(!original.ok||data.status>=400||data.errors)return original;
    const result=await normalize(body.sections,body.sections_url);
    if(kind==='add'){
      // Native notification needs a top-level item key, including multi-item adds.
      const requested=String(body.id||body['items[0][id]']||data.items?.[0]?.id||data.id||'');
      const mapped=window.hpmRoyalBundles?.[requested]?.bundleVariant;
      const selected=result.cart.items.find(i=>String(i.variant_id)===String(mapped))||result.cart.items.find(i=>String(i.variant_id)===requested)||result.cart.items[0];
      return new Response(JSON.stringify({...data,...(selected||{}),sections:result.changed?result.cart.sections:data.sections}),{headers:{'Content-Type':'application/json'}});
    }
    return result.changed?new Response(JSON.stringify({...result.cart,hpmRegrouped:true}),{headers:{'Content-Type':'application/json'}}):original;
  }
  window.HpmBundleCart={plan,normalize:()=>serial(()=>normalize()),request:(url,config,kind)=>serial(()=>perform(url,config,kind)).catch(fail)};
  let passing=false;
  const proceed=async action=>{try{await window.HpmBundleCart.normalize();passing=true;action();}catch(e){alert(e.message);}finally{passing=false;}};
  document.addEventListener('click',e=>{
    if(passing)return;
    const a=e.target.closest('a[href]');
    if(a&&new URL(a.href,location.href).pathname.match(/\/checkout\/?$/)){e.preventDefault();e.stopImmediatePropagation();proceed(()=>location.assign(a.href));}
  },true);
  document.addEventListener('submit',e=>{
    if(passing)return;
    const button=e.submitter;
    if(button?.name==='checkout'){e.preventDefault();e.stopImmediatePropagation();proceed(()=>e.target.requestSubmit(button));}
  },true);
})();
